import React from 'react'
import StoriesList from './StoriesList'


function Stories(props){

    const { stories, showStory } = props

    return (
        <StoriesList stories={stories} showStory={showStory}/>        
    )
}

export default Stories